import React from 'react';
import styled from 'styled-components';

import ButtonSpan from './common/ButtonSpan';

import external from '../assets/img/external.svg';

const Icon = styled.img`
  width: 18px;
  height: 18px;
  margin: 0px 0px 0px 10px;
`;

const RestyledButtonSpan = styled(ButtonSpan)`
  margin-left: 10px;
  font-weight: 400;
  display: inline-block;
  font-size: 1.3em;

  :hover {
    background: #43ad93;
  }

  @media only screen and (max-width: 600px) {
    margin-top: 30px;
  }
`;

const ButtonLink = styled.span`
  :hover {
    color: #ccc;
    cursor: pointer;
  }
`;

const ChooserWrapper = styled.div`
  flex-flow: row;
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: 400;
`;

const StyledH2 = styled.h2`
  justify-content: flex-start;
  margin: 15% 0 40px 0;
`;

const Wrapper = styled.div`
  background: rgba(0, 0, 0, .8);
  flex-flow: column;
  font-weight: 500;
  color: #fff;
  font-size: 1.3em;
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index:0;
`;

const ModalChooser = ({
  closeModal,
  mediaspaceUrl,
  branding: {
    paywall_buttons_bg_color: bgColor,
    paywall_buttons_text_color: textColor,
  },
  translate,
}) => {
  const brandingStyles = {
    background: bgColor,
    color: textColor,
  };

  return (
    <Wrapper className="text-center animated bounceInDown">
      <StyledH2>
        {translate('thank_you_for_your_purchase')}
      </StyledH2>
      <ChooserWrapper>
        <ButtonLink onClick={closeModal}>
          {translate('buy_more_channels')}
        </ButtonLink>
        <RestyledButtonSpan
          padding="18px 30px"
          href={mediaspaceUrl}
          target="_blank"
          {...brandingStyles}
          as="a"
          rel="noopener noreferrer"
        >
          {translate('go_to_premium_content')}
          <Icon src={external} alt={translate('go_to_purchased_channels')} />
        </RestyledButtonSpan>
      </ChooserWrapper>
    </Wrapper>
  );
};

export default ModalChooser;
